import { jsx, jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
const SvgLogout = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ jsxs("svg", { width: 17, height: 17, viewBox: "0 0 17 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props, children: [
  title ? /* @__PURE__ */ jsx("title", { id: titleId, children: title }) : null,
  /* @__PURE__ */ jsx("path", { d: "M13 4.33281L11.872 5.50781L13.936 7.66615H5.8V9.33281H13.936L11.872 11.4828L13 12.6661L17 8.49948L13 4.33281ZM2.6 2.66615H9V0.999481H2.6C1.72 0.999481 1 1.74948 1 2.66615V14.3328C1 15.2495 1.72 15.9995 2.6 15.9995H9V14.3328H2.6V2.66615Z" })
] });
const ForwardRef = /* @__PURE__ */ forwardRef(SvgLogout);
export { ForwardRef as ReactComponent };
import assetUrl from "/home/runner/work/UpstriveEducation-Teacher/UpstriveEducation-Teacher/src/assets/svg/logout.svg?url";
export default assetUrl;
